import { render, staticRenderFns } from "./peopleForm.vue?vue&type=template&id=78ac059e&scoped=true&"
import script from "./peopleForm.vue?vue&type=script&lang=js&"
export * from "./peopleForm.vue?vue&type=script&lang=js&"
import style0 from "./peopleForm.vue?vue&type=style&index=0&id=78ac059e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac059e",
  null
  
)

export default component.exports